export class AsyncTimeoutAbortError extends Error {
  name: string = 'Async timeout aborted';
}

export const asyncTimeout = (
  delay: number,
  signal?: AbortSignal
): Promise<void> =>
  new Promise((resolve, reject) => {
    const timeoutId = setTimeout(resolve, delay);

    if (signal) {
      const onAbort = () => {
        clearTimeout(timeoutId);
        reject(new AsyncTimeoutAbortError());
      };

      if (signal.aborted) {
        onAbort();
      } else {
        signal.addEventListener('abort', onAbort, { once: true });
      }
    }
  });
